import { render, staticRenderFns } from "./ComplexDaycareWrite.vue?vue&type=template&id=0df90207&scoped=true"
import script from "./ComplexDaycareWrite.vue?vue&type=script&lang=js"
export * from "./ComplexDaycareWrite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df90207",
  null
  
)

export default component.exports